import { render } from "./App.vue?vue&type=template&id=17762b70"
const script = {}

import "./App.vue?vue&type=style&index=0&id=17762b70&lang=css"
script.render = render

export default script